// extracted by mini-css-extract-plugin
export default {"eventContainer":"U1fIEbwITJ8Wwi98vEaQ","eventImageContainer":"YZKIDujNw82mdJX5bVHy","eventTitle":"CPLL_0Z0g46o2dZyvfNg","eventTimeDetail":"iDhWdMfWI9KNLBOCwkFu"};